import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EpdkListItemComponent } from './list-item.component';
import { EpdkListComponent } from './list.component';

@NgModule({
  imports: [CommonModule],
  declarations: [EpdkListComponent, EpdkListItemComponent],
  exports: [EpdkListComponent, EpdkListItemComponent]
})
export class EpdkListModule { }